import { SVGProps } from "react";

const STIJulia = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" aria-label="Julia" role="img" viewBox="0 0 512 512" width="1em" height="1em" {...props}><rect width={512} height={512} rx="15%" fill="#fff" /><circle fill="#389826" cx={256} cy={137} r={83} /><circle fill="#cb3c33" cx={145} cy={329} r={83} /><circle fill="#9558b2" cx={367} cy={329} r={83} /></svg>;

export { STIJulia };